// extracted by mini-css-extract-plugin
export default {"title":"lba-z","warning":"mba-z","sizeOptionsLegendText":"nba-z"};